import InputText from 'modules/core/components/Inputs/Text'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { ChargebeeSubscriptionForm } from 'modules/billing/components/PaymentGateway/FullScreenStep/form'
import {
  DEFAULT_IBAN_PLACEHOLDER,
  IBAN_PLACEHOLDERS,
} from 'modules/billing/components/PaymentGateway/FullScreenStep/helpers'

type Props = {
  form: ChargebeeSubscriptionForm
}

const BankTransferFields = ({ form }: Props) => {
  const country = form.get('country').value
  const ibanPlaceholder = IBAN_PLACEHOLDERS[country] || DEFAULT_IBAN_PLACEHOLDER

  return (
    <InputText
      label={i18n.t('pricing_plans.billing_information.form.iban')}
      field={form.get('iban')}
      mandatory
      placeholder={ibanPlaceholder}
      onChange={(e) => {
        form.setErrors({ iban: {} })
        form.setValues({ iban: e.value.toUpperCase() })
      }}
      onBlur={() => {
        if (form.get('iban').value !== '' && !form.isValidIban) {
          track(trackingEvents.billing.upgradePlanError, {
            error_message: 'Invalid IBAN',
            value: form.get('iban').value,
          })
          form.setErrors({
            iban: [i18n.t('pricing_plans.billing_information.form.validation.invalid_iban')],
          })
        }
      }}
    />
  )
}

export default BankTransferFields
